<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <!-- top buttons  -->
      <div class="col-12">
        <div class="card mb-4">
          <span class="top-actions">
            <!--  -->
            <button
              type="button"
              class="mycustom-success-button"
              @click="showItemsCreateModal(null)"
            >
              <i class="bi bi-plus-square-dotted"></i> Add Item
            </button>

            <button
              type="button"
              class="mycustom-success-button"
              data-bs-toggle="modal"
              data-backdrop="static"
              data-keyboard="false"
              data-bs-target="#UploadItemModal"
            >
              <i class="bi bi-plus-square-dotted"></i>
              <i class="bi bi-plus-circle-dotted"></i> Upload Items
            </button>
          </span>
        </div>
      </div>
      <!-- end top buttons -->
      <BaseLayout
        :mainUrl="mainUrl"
        :tableSearchUrl="searchUrl"
        :searchPlaceholder="placeHolderText"
        @child-data-state-mount="handle_external_mount"
      >
        <template v-slot:table-heading>
          <th
            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
          >
            #s/n
          </th>
          <th
            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
          >
            Item Name
          </th>

          <th
            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
          >
            Barcode
          </th>

          <th
            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
          >
            Class & Category
          </th>

          <th
            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
          >
            Reorder Level
          </th>

          <th
            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
          >
            Min-Quantity
          </th>

          <th class="text-secondary opacity-7"></th>
        </template>

        <template v-slot:table-contents-place>
          <tr v-for="user in users" :key="user.id">
            <td>#{{ user.id }}</td>
            <td>
              <!-- {{ user.item_name  }} -->
              <itemname
                :ItemName="user.item_name"
                :ItemBrand="user.brand_name"
                :ItemStrength="user.item_strength"
              />
            </td>
            <td>
              {{ user.barcode }}
            </td>
            <td>
              <div class="d-flex px-2 py-1">
                <div></div>
                <div class="d-flex flex-column justify-content-center">
                  <h6 class="mb-0 text-sm">{{ user.class_name }}</h6>
                  <p class="text-xs text-secondary mb-0">
                    {{ user.category_name }}
                  </p>
                </div>
              </div>
            </td>

            <td>
              {{ user.reorder_level }}
            </td>

            <td>
              {{ user.min_quantity }}
            </td>

            <td class="align-middle">
              <button @click="showItemsCreateModal(user)">Edit</button>.
              <button @click="delete_item(user.id)">Delete</button>.
            </td>
          </tr>
        </template>
      </BaseLayout>
    </div>
  </div>

  <CreateItemModal
    v-if="showItemsCreationModal"
    @close-create-item-modal="closeItemsCreateModal"
    :item_id="this.current_item_id"
  />
  <ItemUploadModal />
</template>

<script>
import BaseLayout from "../Patients/components/table_page_layout.vue";
// import formatDateTime from "../../timezone/utc_local_time.js";
import { generalApiRequest } from "../../api/apiIndex";
// import Pagination from "../components/pagination.vue";
// import Search from "../components/search.vue";
import Itemname from "./components/ItemName.vue";
import CreateItemModal from "./modals/createItem.vue";
import ItemUploadModal from "./modals/ItemUpload.vue";
//import axios from "axios";

export default {
  name: "itemregister",
  data() {
    return {
      users: [],
      allData: {},
      apiLoading: true,
      tableLoading: true,
      placeHolderText: "Search name,phone,email,opd/ipd",
      searchUrl: "inventory/searchCompanyItems",
      mainUrl: "inventory/getAllCompanyItems",
      current_item_id: null,
      showItemsCreationModal: false,
    };
  },
  components: {
    BaseLayout,
    CreateItemModal,
    ItemUploadModal,
    Itemname,
  },

  methods: {
    async delete_item(item_id) {
      const url = "deleteCompanyItem";
      const body = { item_id: item_id };
      await generalApiRequest(url, "POST", body, 1);
      window.location.reload();
    },
    handle_external_mount(payload) {
      this.users = payload;
      console.log(this.users);
    },
    closeItemsCreateModal() {
      this.current_item_id = null;
      this.showItemsCreationModal = false;
      window.location.reload();
    },
    showItemsCreateModal(item_id) {
      this.current_item_id = item_id?.id;
      this.showItemsCreationModal = true;
    },

    handleContentChange(contents) {
      // console.log("procceds");
      // console.log(contents);
      this.users = contents;
    },

    loaderSet(value) {
      if (value == true) {
        this.users = [];
      }
      this.tableLoading = value;
      //console.log(value);
      //this.apiLoading = value;
    },

    async callApi() {
      try {
        const url = "inventory/getAllCompanyItems"; //?page=1
        const body = {};

        // const data = await getMethodRequest(url, body, 1);
        const data = await generalApiRequest(url, "GET", body, 1);
        //console.log(data);
        this.allData = data;
        this.apiLoading = false;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
  },

  mounted() {
    this.callApi();
  },
};
</script>

<style>
table {
  table-layout: auto; /* Let columns expand naturally */
  width: 100%;
}

th,
td {
  white-space: normal !important; /* Allow wrapping */
  word-wrap: break-word; /* Break long words */
  vertical-align: middle;
}
</style>
